$(function() {
    const DeviceDetector = require('device-detector');

    $('.js-showed-map').each((i, el) => initMap(el));

    function initMap(el) {
        const isNotMobile = !(DeviceDetector.parse(navigator.userAgent)
            .type === 'Mobile');

        var lat = $(el).data('lat')
        var lng = $(el).data('lng')

        var centerMap = {lat: parseFloat(lat), lng: parseFloat(lng)}
        var map = new google.maps.Map(el, {
            zoom: 15,
            center: centerMap,
            marker: centerMap,
            zoomControl: false,
            clickableIcons: false,
            mapTypeControl: isNotMobile,
            streetViewControl: isNotMobile,
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.BOTTOM_CENTER
            }
        });

        var marker = new google.maps.Marker({
            position: centerMap,
            map: map
        })

        var zoomControlDiv = document.createElement('div');
        var zoomControl = new ZoomControl(zoomControlDiv, map);

        zoomControlDiv.index = 1;
        map.controls[google.maps.ControlPosition.TOP_LEFT].push(zoomControlDiv);
    }

    function ZoomControl(controlDiv, map) {
        $(controlDiv).addClass('map-zoom-control');

        const controlWrapper = document.createElement('div');
        $(controlWrapper).addClass('map-zoom-control__wrap');
        controlDiv.appendChild(controlWrapper);

        const plus = document.createElement('i');
        plus.setAttribute('aria-hidden', 'true');
        const minus = plus.cloneNode();

        $(plus).addClass('fa fa-plus');
        $(minus).addClass('fa fa-minus');

        const zoomInButton = document.createElement('div');
        $(zoomInButton).addClass('map-zoom-control__btn');
        zoomInButton.appendChild(plus);
        controlWrapper.appendChild(zoomInButton);

        const zoomOutButton = document.createElement('div');
        $(zoomOutButton).addClass('map-zoom-control__btn');
        zoomOutButton.appendChild(minus);
        controlWrapper.appendChild(zoomOutButton);

        google.maps.event.addDomListener(zoomInButton, 'click', function() {
            map.setZoom(map.getZoom() + 1);
        });

        google.maps.event.addDomListener(zoomOutButton, 'click', function() {
            map.setZoom(map.getZoom() - 1);
        });
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/product/map.js